import styled, { css } from 'styled-components';
import {
    spaceMixin, mediaMixin, Flex,
} from '@zillow/constellation';

export const StyledFlexLeaseCard = styled(Flex)`
    min-width: 0;

    ${mediaMixin('md', css`
        &.LeaseCard-Even.LeaseCard-Multiple {
            padding-right: ${spaceMixin('sm')};
        }
    `)}

    ${mediaMixin('lg', css`
        &.LeaseCard-Even.LeaseCard-Multiple {
            padding-right: 0;
        }
    `)}
`;

export const ConnectedLeaseContainer = styled(Flex)`
    width: 100%;

    ${mediaMixin('lg', css`
        /* Dont display cards starting at the 3rd index */
        .LeaseCard:nth-of-type(1n+3) {
            display: none;
        }
    `)}
`;

export const StyledDivider = styled.span`
    width: 2px;
    height: 16px;
    border: solid 1px #d1d1d5;
    margin-top: ${spaceMixin('sm')};
    margin-bottom: ${spaceMixin('sm')};
`;
